var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.getNavBackground()},[_c('div',{staticClass:"nav-top"},[_c('nav-top')],1),_vm._v(" "),(_vm.moduletag === 2)?_c('div',[_c('org-nav-bottom')],1):_c('div',[_c('jujia-nav')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2edda8af","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/navbar/index.vue
// module id = null
// module chunks = 